import {$, w} from './constants';
import { mapInit } from './map';
import { archiveInit } from './archive';

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');
    
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');
    
});
if( $('#map_container').length ){
    mapInit();
}

if( $('#archive_container').length ){
    archiveInit();
}

// HEADER NAV
if($(".header-nav").length ){
    document.addEventListener("DOMContentLoaded", function () {
        const menuToggle = document.querySelector(".nav-toogle");
        const navList = document.querySelector(".header-nav");
        const menuClose = document.querySelector(".nav-close")
    
        menuToggle.addEventListener("click", function () {
            navList.classList.toggle("active");
        });
    
    });
}

// HOME NAV MOVEMENT
$('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .not('[href="#contact"]')
    .click(function(event) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            let target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

            if (target.length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - 80
                }, 1000);
                
            }
        }
    });

$(window).on('load', function() {
    console.log('Hello world from El Cultivo! --Load');
    let sun_tl = gsap.timeline();
    let menu_tl = gsap.timeline();

    //Animación Sol
    if($('#scrollingElement').length){
        ScrollTrigger.matchMedia({

            // desktop
            "(min-width: 651px)": function() {
                sun_tl.to('#scrollingElement', {
                    scrollTrigger : {
                        trigger: '#startTriggerScrolling',
                        scrub: 1,
                        start : "top",
                        end : "bottom+=200",
                        markers : false,
                        onEnter: (self) => {
                            $('#scrollingElement').addClass('fixedel');
                        },
                        onLeave: (self) => {
                            $('#scrollingElement').removeClass('fixedel');
                        },
                        onToggle : () => {
                            $('#scrollingElement').toggleClass('fixedel');
                        }
                    }
                });
                sun_tl.to('#scrollingElement', {
                    opacity: 0,
                    scrollTrigger : {
                        trigger: '#triangleScrolling',
                        scrub: 1,
                        start : "top",
                        end : "bottom",
                        markers : false,
                        onEnter: (self) => {
                            gsap.to('#scrollingElement', { opacity: 0, duration: 0.3 });
                        },
                        onLeave: ()=>{
                            gsap.to('#scrollingElement', { opacity: 1, duration: 0.3 });
                        }
                    }
                });
            },
            // mobile
            "(max-width: 650px)": function() {
                sun_tl.to('#scrollingElement', {
                    scrollTrigger : {
                        trigger: '#startTriggerScrolling',
                        scrub: 1,
                        start : "top+=350",
                        end : "bottom+=200",
                        markers : false,
                        onEnter: (self) => {
                            $('#scrollingElement').addClass('fixedel');
                        },
                        onLeave: (self) => {
                            $('#scrollingElement').removeClass('fixedel');
                        },
                        onToggle : () => {
                            $('#scrollingElement').toggleClass('fixedel');
                        }
                    }
                });
                sun_tl.to('#scrollingElement', {
                    opacity: 0,
                    scrollTrigger : {
                        trigger: '#triangleScrolling',
                        scrub: 1,
                        start : "top-=60",
                        end : "bottom+=100",
                        markers : false,
                        onEnter: (self) => {
                            gsap.to('#scrollingElement', { opacity: 0, duration: 0.3 });
                        },
                        onLeave: ()=>{
                            gsap.to('#scrollingElement', { opacity: 1, duration: 0.3 });
                        }
                    }
                });
            }
        });
        
    }

    //Header en Home
    if($('#startHeaderScrolling').length){
        menu_tl.to('#header_main', {
            scrollTrigger : {
                trigger: '#startHeaderScrolling',
                endTrigger: "#headerScrollable",
                scrub: true,
                start : "start 0",
                end : "bottom 50%",
                toggleActions : "restart pause resume pause",
                markers : false,
                onEnter: (self) => {
                    $('#header_main').addClass('active');
                    $('#header_aux').addClass('active');
                },
                onLeave: (self) => {
                    $('#header_main').removeClass('active');
                    $('#header_aux').removeClass('active');
                },
                onToggle : () => {
                    $('#header_main').toggleClass('active');
                    $('#header_aux').toggleClass('active');
                }
            }
        });
    }
});
/* MENÚ M ó v i l */
if($(window).width() < 951 ){
    $('li.menu-item-has-children').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass('active');
    })
    $('li.menu-item-has-children > .sub-menu').on('click', function(e){
        e.stopPropagation();
    });
}
$('#open_menu_mobile_aside').on('click', function(){
    $('#menu_mobile_aside').fadeIn(200);
})
$('#close_menu_mobile_aside').on('click', function(){
    $('#menu_mobile_aside').fadeOut(200);
})
/* END MENÚ M ó v i l */

// SOBRE EL PROYECTO CAROUSEL

$('#carrusel_blog').slick({
    infinite: true,
    autoplay: false,
    lazyLoad: 'ondemand',
    autoplaySpeed: 5000,
    speed: 400,
    slidesToShow: 1,
    arrows: true,
    adaptiveHeight: true,
    prevArrow: '.arrow Blogleft-arrow',
    nextArrow: '.arrow Blogright-arrow',
    responsive: [
        {
            breakpoint: 951,
            settings: {
                arrows: true,
                adaptiveHeight: true,
            },
            
        }
    ]
    
});
$('#prevButton').on('click', function() {
    $('#carrusel_blog').slick('slickPrev');
});
$('#nextButton').on('click', function() {
    $('#carrusel_blog').slick('slickNext');
});
